/* eslint-disable react/jsx-no-comment-textnodes */
import ClassTable from "../Components/ClassTable";
import "./CourseDetails.css";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useFetch from "../Components/utils/useFetch";
import uuid from "react-uuid";
import Loader from "../Components/utils/Loader";
import "../Components/utils/Loader.css";

function CourseDetails() {
  const [termData, setTermData] = useState();
  let location = useLocation();
  let i = 1;
  let j = i + 1;

  if (process.env.PUBLIC_URL === "/class-schedule") {
    i = 2;
    j = i + 1;
  }

  const currentTerm = location.pathname.split("/")[i];
  const currentClass = location.pathname.split("/")[j];
  const currentFull = `${currentTerm + "/" + currentClass}`;
  const { get, loading } = useFetch();
  const [attributeCodes, setAttributes] = useState([]);
  const [sessionCodes, setSession] = useState([]);
  let [pageTitle, setPageTitle] = useState(`${currentClass} | ${transormTermString(currentTerm)} | Sacramento State`);

  useEffect(() => {
    get(`${currentFull}`).then((data) => {
      setTermData(data);

      get(`classattributes/${currentTerm}/${data[0].subject_code}`).then(
        (attr) => {
          setAttributes(attr);
        }
      );
      get(`sessionattributes/${currentTerm}/${data[0].subject_code}`).then(
        (attr) => {
          setSession(attr);
        }
      );
    });
  }, []);

  useEffect(() => {
     const prettyString = transormTermString(pageTitle)
     document.title = prettyString;
  }, [location.pathname]);

  function transormTermString(str) {
    // Trim first off string
    const trimmedStr = str.trimStart();
    // Capitalize new first letter
    const capitalizedStr = trimmedStr.charAt(0).toUpperCase() + trimmedStr.slice(1);
    // Replace hyphen with space
    const replacedStr = capitalizedStr.replace("-", " ");
    return replacedStr;
}

  return (
    <div
      className="page-schedule-details"
      role="region"
      aria-label="course-details"
    >
      <h1>Class Schedule</h1>
      {loading ? <Loader /> : null}
      <article>
        <section>
          <div className="toc-header">
            <h2 id="article-head">{termData && termData[0].subject_ldesc}</h2>
            <p>
              All Courses in {termData && termData[0].subject_ldesc} available
              in{" "}
              {currentTerm
                .replace("-", " ")
                .replace(/(?:^|\s)\S/g, (a) => a.toUpperCase())}
            </p>
          </div>
        </section>
        <aside className="side-nav">
          <h3 aria-hidden>Jump to Course</h3>
          <ul className="toc-wrapper">
            {termData &&
              termData.map((item) => (
                <li key={uuid()} className="toc-card">
                  <a href={"#" + item.subject_code + "-" + item.catalog_number}>
                    {item.subject_code + " " + item.catalog_number}
                  </a>
                </li>
              ))}
          </ul>
        </aside>

        <section>
          {/* Table here */}
          <div className="table-section">
            {termData &&
              termData.map((item) => (
                <ClassTable key={uuid()} section={item} />
              ))}
          </div>
          <footer>
            <div className="legend">
              <h2>Legend</h2>
              <ul>
                <li>
                  <span>
                    <img
                      src="//www.csus.edu/dev/class_schedule/book-icon-big.png"
                      alt="Book Legend Icon"
                    />
                  </span>
                  The icon links you to the identified course materials list.
                </li>
                <li>
                  <span>
                    <img
                      src="//www.csus.edu/dev/class_schedule/low-cost-book-icon-big.png"
                      alt="Low Cost Course Materials Legend Icon"
                    />
                  </span>
                  This course has been identified as having total course
                  material costs under $40.00. Costs are determined by the
                  campus affiliated book store. Availability of low cost
                  materials may be limited to bookstore availability.
                </li>
                <li>
                  <span>
                    <img
                      src="//www.csus.edu/dev/class_schedule/zero-cost-book-icon-big.png"
                      alt="Zero Cost Course Materials Legend Icon"
                    />
                  </span>
                  This course has been identified as having Zero cost course
                  materials.
                </li>
              </ul>
            </div>

            <div className="attributes">
              <h2>Class Attribute Codes</h2>
              {attributeCodes && attributeCodes.length > 0 && (
                <ul>
                  {attributeCodes.map((item) => (
                    <li key={uuid()}>
                      <span>{item.course_attribute_value}</span>
                      <span>{item.course_attribute_ldesc}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="session">
              <h2>Session Codes</h2>
              {sessionCodes && sessionCodes.length > 0 && (
                <ul>
                  {sessionCodes.map((item) => (
                    <li key={uuid()}>
                      <span>{item.session_code}</span>
                      <span>{item.session_ldesc_long}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </footer>
        </section>
      </article>
    </div>
  );
}

export default CourseDetails;
